// components/dialogs/OptionDialog.jsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Box,
  TextField,
} from "@mui/material";

import Api from "../../Api/Api";
import { toast } from "sonner";

export default function OptionDialog({
  duplicateDialog,
  setDuplicateDialog,
  pendingDuplicateRow,
  setAllowDuplicateOnce,
  fetchData,
  withLoading,
}) {
  return (
    <Dialog open={duplicateDialog} onClose={() => setDuplicateDialog(false)}>
      <DialogTitle>Duplicate Connote</DialogTitle>

      <DialogContent>
        This connote already exists. Continue anyway?
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setDuplicateDialog(false)}>Cancel</Button>

        <Button
          variant="contained"
          onClick={async () => {
            try {
              setDuplicateDialog(false);

              setAllowDuplicateOnce(true);

              const cleanRow = { ...pendingDuplicateRow };

              delete cleanRow.owner_name;
              delete cleanRow.isNew;
              delete cleanRow.creation_log;
              delete cleanRow.days_active;
              delete cleanRow.days_with_carrier;

              await Api.post("/dashboard/update", {
                id: String(cleanRow.id).replace("temp-", ""),
                data: cleanRow,
              });

              await withLoading(async () => {
                await fetchData();
              }, "Loading records...");

              setTimeout(() => {
                setAllowDuplicateOnce(false);
              }, 500);

              toast.success("Saved");
            } catch (err) {
              console.log(err.response?.data);

              setAllowDuplicateOnce(false);

              toast.error("Save failed");
            }
          }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
